module.exports = __webpack_public_path__ + "img/PERSONAL_DETAILS_UPDATE.png";